export interface Token {
  accessToken: string;
  refreshToken: string;
}

export const tokenExpiration = 5; // minutes

export const anonymousToken: Token = { accessToken: '', refreshToken: '' };
